import { Button, Callout, EditableText } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as React from 'react'
import { connect } from 'react-redux'
import { dispatch, RootState, select, store } from '../../store'
import Avatar from '../Avatar'
import { CardContainer } from '../Card'
import Icon from '../Icon'
import styles from './personal-card.scss'


const cx = classnames.bind(styles)

interface IProps extends React.HTMLProps<HTMLDivElement> {
  userId: string
  theme: string
  deviceType: string
  onConfirm: () => void
}

interface IState {
  job: {
    organization: string,
    title: string,
  },
  error: Error | null,

}

class PersonalCard extends React.PureComponent<IProps, IState> {
  public state: IState = {
    job: {
      organization: '',
      title: '',
    },
    error: null,
  }

  public handleNameSave = (fullName: string) => {
    const currentUser = firebase.auth().currentUser
    if (currentUser) {
      currentUser.updateProfile({
        displayName: fullName,
        photoURL: currentUser.photoURL,
      })
        .then(_ => dispatch.auth.updateUser(currentUser))
        .catch(error => this.setState({ error }))
    }
  }

  public handleTitleSave = (title: string) => {
    dispatch.users.updateProfile({ title })
  }

  public handleDescriptionSave = (description: string) => {
    dispatch.users.updateProfile({ description })
  }

  public handleJobOrgSave = (jobs: IJob[], idx: number, value: string) => {
    dispatch.users.updateProfile({
      jobs: [
        ...jobs.slice(0, idx),
        {
          ...jobs[idx],
          organization: value,
        },
        ...jobs.slice(idx + 1),
      ]
    })
  }

  public handleJobTitleSave = (jobs: IJob[], idx: number, value: string) => {
    dispatch.users.updateProfile({
      jobs: [
        ...jobs.slice(0, idx),
        {
          ...jobs[idx],
          title: value,
        },
        ...jobs.slice(idx + 1),
      ]
    })
  }
  public handleJobDelete = (jobs: IJob[], idx: number) => {
    dispatch.users.updateProfile({
      jobs: [
        ...jobs.slice(0, idx),
        ...jobs.slice(idx + 1),
      ]
    })
  }
  public handleJobAdd = (jobs: IJob[]) => {
    dispatch.users.updateProfile({ jobs: [...jobs, this.state.job] })
      .then(_ => this.setState({ job: { organization: '', title: '' } }))
  }

  public handleNewJobOrgSave = (value: string) => {
    this.setState({ job: { ...this.state.job, organization: value } })
  }

  public handleNewJobTitleSave = (value: string) => {
    this.setState({ job: { ...this.state.job, title: value } })
  }

  public fetchData = (props: IProps) => {
    const rootState = store.getState()
    const { userId } = props
    const user = select.users.getById(rootState, userId)
    if (user === null) {
      dispatch.users.fetchUsers([userId])
    }
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    if (nextProps.userId !== this.props.userId) {
      this.fetchData(nextProps)
    }
  }

  public componentDidMount = () => {
    this.fetchData(this.props)
  }

  public render() {
    const { className, userId, theme, deviceType, onConfirm } = this.props
    const rootState = store.getState()
    const user = select.users.getById(rootState, userId)
    return (
      <CardContainer className={cx('profile-card', className)}>
        <Avatar editable={true} className={cx('profile-card__avatar')} userId={userId} />
        {/* <Button onClick={th}>編輯</Button>
        <label className={cx('btn', 'btn--md', 'btn--primary')}>
          {material.downloadUrl ? '重新上傳' : '上傳'}
          <FileUploader
            hidden={true}
            accept="image/*"
            storageRef={firebase.storage().ref(currentUser.uid)}
            onUploadStart={this.onUploadStart}
            onUploadError={this.onUploadError}
            onUploadSuccess={this.onUploadSuccess}
            onProgress={this.onProgress}
          />
        </label> */}



        <div className={cx('profile-card__content')}>
          <div className={cx('profile-card__preview-btn')}>
            <div onClick={onConfirm} className={cx('btn', `btn--${theme}`, `btn--${deviceType}`)} >
              存儲並瀏覽個人資料
              </div>
          </div>

          {this.state.error ? <Callout>{this.state.error.message}</Callout> : null}

          {/* user name */}
          <div className={cx('profile-card__info-item')}>
            <div className={cx('profile-card__info-label')}>名稱</div>
            <div className={cx('profile-card__info-content')}>
              <h3 className={cx('name')}>{user ? <EditableText placeholder="屬於你的名字" defaultValue={user.fullName} onConfirm={this.handleNameSave} /> : 'N/A'}</h3>
              <button className={cx('edit-btn', 'icon')} title="編輯"><Icon type="edit" /></button>
            </div>
          </div>

          {/* user title */}
          <div className={cx('profile-card__info-item')}>
            <div className={cx('profile-card__info-label')}>稱號</div>
            <div className={cx('profile-card__info-content')}>
              <h3 className={cx('para')}>{user ? <EditableText placeholder="用一句話代表自己！" defaultValue={user.title || ''} onConfirm={this.handleTitleSave} /> : 'N/A'}</h3>
              <button className={cx('edit-btn', 'icon')} title="編輯"><Icon type="edit" /></button>
            </div>
          </div>

          {/* user description */}
          <div className={cx('profile-card__info-item')}>
            <div className={cx('profile-card__info-label')}>關於</div>
            <div className={cx('profile-card__info-content')}>
              <h3 className={cx('para')}>{user ? <EditableText placeholder="簡單介紹一下自己吧！" defaultValue={user.description || ''} multiline={true} onConfirm={this.handleDescriptionSave} /> : 'N/A'}</h3>
              <button className={cx('edit-btn', 'icon')} title="編輯"><Icon type="edit" /></button>
            </div>
          </div>

          {/* user job */}
          <div className={cx('profile-card__info-item')}>
            <div className={cx('profile-card__info-label')}>經歷</div>
            <div className={cx('profile-card__info-content')}>
              {
                user ? user.jobs.map((job, idx) => (
                  <p key={job.organization + job.title} className={cx('para', 'workpara')}>
                    <div>
                      <span className={cx('workspan')}><EditableText placeholder="公司名稱" defaultValue={job.organization} onConfirm={this.handleJobOrgSave.bind(this, idx)} /></span>&#32;
                      <span className={cx('workspan')}><EditableText placeholder="公司職位" defaultValue={job.title} onConfirm={this.handleJobTitleSave.bind(this, idx)} /></span>
                      <Button className={cx('icon')} icon="trash" onClick={this.handleJobDelete.bind(this, user.jobs, idx)} />
                    </div>
                  </p>
                )) : null
              }
              <p className={cx('para', 'workpara')}>
                <div>
                  <span className={cx('workspan')}><EditableText placeholder="公司名稱" onConfirm={this.handleNewJobOrgSave} /></span>&#32;
                  <span className={cx('workspan')}><EditableText placeholder="公司職位" onConfirm={this.handleNewJobTitleSave} /></span>
                  <Button className={cx('icon')} icon="add" onClick={this.handleJobAdd.bind(this, user ? user.jobs : [])} />
                </div>
              </p>
            </div>
          </div>
        </div>
      </CardContainer>
    )
  }
}

const mapState = ({ users }: RootState) => ({ users })
export default connect(mapState)(PersonalCard)



// WEBPACK FOOTER //
// ./src/components/PersonalCard/index.tsx